import { b as private_env } from "../../chunks/shared-server.js";
import { g as getOAuthConfig } from "../../chunks/oauth.js";
const load = async (event) => {
  return {
    readOnly: private_env.MONGOKU_READ_ONLY_MODE === "true",
    serverOrigin: event.url.origin,
    oauthEnabled: !!await getOAuthConfig(),
    user: event.locals.user
  };
};
export {
  load
};
